import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-deceased-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-deceased-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDeceasedCmConstants } from "./create-application-deceased-cm.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { BehaviorSubject } from "rxjs";
import { DeceasedNamesHeadingEnumHeadingLookup } from "./deceased-names-heading.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddDeceasedNameComponent } from "./add-deceased-name/add-deceased-name.component";
import { AlertType } from "../../../../../shared/models/alert";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import * as AflaPortalDocumentConstants from "../../../../../core/settings/components/afla-portal-documents/afla-portal-documents.constants";
import { EditDeceasedNameComponent } from "./edit-deceased-name/edit-deceased-name.component";
import { DatePipe } from "@angular/common";
import { take, takeUntil } from "rxjs/operators";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationDeceasedCmComponent = class CreateApplicationDeceasedCmComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    modalService;
    datePipe;
    changeDetectorRefs;
    deceasedForm;
    validationMessages = CreateApplicationDeceasedCmConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    tableDataSource = new BehaviorSubject([]);
    // @ts-ignore
    tableMapper;
    tableSelection = [];
    deleteLabel = SharedConstants.REMOVE_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    addLabel = SharedConstants.ADD_LABEL;
    deceasedDetailsLabel = CreateApplicationDeceasedCmConstants.DECEASED_DETAILS_LABEL;
    captureDeceasedDetailsLabel = CreateApplicationDeceasedCmConstants.CAPTURE_DECEASED_DETAILS_LABEL;
    sexLabel = CreateApplicationDeceasedCmConstants.SEX_LABEL;
    nationalityLabel = CreateApplicationDeceasedCmConstants.NATIONALITY_LABEL;
    identificationTypeLabel = CreateApplicationDeceasedCmConstants.IDENTIFICATION_TYPE_LABEL;
    idNumberLabel = CreateApplicationDeceasedCmConstants.ID_NUMBER_LABEL;
    dateOfBirthLabel = CreateApplicationDeceasedCmConstants.DATE_OF_BIRTH_LABEL;
    dateOfDeathLabel = CreateApplicationDeceasedCmConstants.DATE_OF_DEATH_LABEL;
    placeOfBirthLabel = CreateApplicationDeceasedCmConstants.PLACE_OF_BIRTH_LABEL;
    placeOfDeathLabel = CreateApplicationDeceasedCmConstants.PLACE_OF_DEATH_LABEL;
    maidenNameLabel = CreateApplicationDeceasedCmConstants.MAIDEN_NAME_LABEL;
    provinceOfDeathLabel = CreateApplicationDeceasedCmConstants.PROVINCE_OF_DEATH_LABEL;
    burialOrderNumberLabel = CreateApplicationDeceasedCmConstants.BURIAL_ORDER_NUMBER_LABEL;
    serialNumberLabel = CreateApplicationDeceasedCmConstants.SERIAL_NUMBER_LABEL;
    verticalPositionLabel = CreateApplicationDeceasedCmConstants.VERTICAL_POSITION_LABEL;
    nameOfUndertakerLabel = CreateApplicationDeceasedCmConstants.NAME_OF_UNDERTAKER_LABEL;
    sexFormControlName = CreateApplicationDeceasedCmConstants.SEX_FORM_CONTROL_NAME;
    nationalityFormControlName = CreateApplicationDeceasedCmConstants.NATIONALITY_FORM_CONTROL_NAME;
    identificationTypeFormControlName = CreateApplicationDeceasedCmConstants.IDENTIFICATION_TYPE_FORM_CONTROL_NAME;
    idNumberFormControlName = CreateApplicationDeceasedCmConstants.ID_NUMBER_FORM_CONTROL_NAME;
    dateOfBirthFormControlName = CreateApplicationDeceasedCmConstants.DATE_OF_BIRTH_FORM_CONTROL_NAME;
    dateOfDeathFormControlName = CreateApplicationDeceasedCmConstants.DATE_OF_DEATH_FORM_CONTROL_NAME;
    placeOfBirthFormControlName = CreateApplicationDeceasedCmConstants.PLACE_OF_BIRTH_FORM_CONTROL_NAME;
    placeOfDeathFormControlName = CreateApplicationDeceasedCmConstants.PLACE_OF_DEATH_FORM_CONTROL_NAME;
    maidenNameFormControlName = CreateApplicationDeceasedCmConstants.MAIDEN_NAME_FORM_CONTROL_NAME;
    provinceOfDeathFormControlName = CreateApplicationDeceasedCmConstants.PROVINCE_OF_DEATH_FORM_CONTROL_NAME;
    burialOrderNumberFormControlName = CreateApplicationDeceasedCmConstants.BURIAL_ORDER_NUMBER_FORM_CONTROL_NAME;
    serialNumberFormControlName = CreateApplicationDeceasedCmConstants.SERIAL_NUMBER_FORM_CONTROL_NAME;
    verticalPositionFormControlName = CreateApplicationDeceasedCmConstants.VERTICAL_POSITION_FORM_CONTROL_NAME;
    nameOfUndertakerFormControlName = CreateApplicationDeceasedCmConstants.NAME_OF_UNDERTAKER_FORM_CONTROL_NAME;
    deleteSuccessMessage = SharedConstants.REMOVE_SUCCESS;
    removeDialogTitle = AflaPortalDocumentConstants.REMOVE_DIALOG_TEXT;
    removeContent = `${SharedConstants.REMOVE_MESSAGE} name(s)?`;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneDocMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    sexTypes = [];
    countryOptions = LookupConstants.COUNTRIES;
    idTypes = [];
    verticalPositionTypes = [];
    provinceOptions = LookupConstants.PROVINCE;
    dateofBirth;
    modalOptions = {
        size: "lg",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
    today = new Date();
    pauperApplicationTypeName = "";
    requiredFieldState = {
        sex: true,
        nationality: true,
        identificationType: true,
        idNumber: true,
        dateOfBirth: true,
        placeOfBirth: true,
        burialOrderNumber: true,
        verticalPosition: true
    };
    constructor(createApplicationService, aflaModuleStrategyService, appController, modalService, datePipe, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.modalService = modalService;
        this.datePipe = datePipe;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.sexTypes = defaults.sexTypes;
            this.idTypes = defaults.idTypes;
            this.verticalPositionTypes = defaults.verticalPositionTypes;
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("sexTypes")) {
                this.sexTypes = this.aflaModuleStrategyService.lookups.get("sexTypes");
                this.idTypes = this.aflaModuleStrategyService.lookups.get("idTypes");
                this.verticalPositionTypes = this.aflaModuleStrategyService.lookups.get("verticalPositionTypes");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initializeColumnToObjectMapping();
        this.initForm();
        this.syncTable();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
        this.pauperApplicationTypeName = this.getPauperApplicationTypeName(stepMeta);
        this.refreshBurialTypeValidationState();
    }
    initForm() {
        this.deceasedForm = this.aflaModuleStrategyService.form.get("deceasedForm");
        const detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        const burialTypeValue = detailsForm.get(CreateApplicationDeceasedCmConstants.BURIAL_TYPE_FORM_CONTROL_NAME).value?.value;
        this.refreshBurialTypeValidationState();
        this.applyBurialTypeValidationState(burialTypeValue);
    }
    getBurialTypeText(selectedBurialType) {
        if (selectedBurialType === null || selectedBurialType === undefined) {
            return "";
        }
        if (typeof selectedBurialType === "string") {
            return selectedBurialType;
        }
        const lookupValue = selectedBurialType.value;
        if (lookupValue === null || lookupValue === undefined) {
            return "";
        }
        return String(lookupValue);
    }
    applyBurialTypeValidationState(burialTypeText) {
        const isPauperBurialType = this.isPauperBurialType(burialTypeText);
        if (isPauperBurialType) {
            this.clearPauperOptionalValidators();
        }
        else {
            this.applyRequiredValidators();
        }
        this.requiredFieldState = this.buildRequiredFieldState(!isPauperBurialType);
        this.deceasedForm.updateValueAndValidity({ emitEvent: false });
        this.changeDetectorRefs.detectChanges();
    }
    isPauperBurialType(burialTypeText) {
        const normalizedPauperApplicationTypeName = this.pauperApplicationTypeName.trim().toLowerCase();
        if (normalizedPauperApplicationTypeName === "") {
            return false;
        }
        const normalizedBurialType = burialTypeText.toLowerCase();
        return normalizedBurialType.includes(normalizedPauperApplicationTypeName);
    }
    getPauperApplicationTypeName(stepMeta) {
        if (stepMeta === null || stepMeta === undefined) {
            return "";
        }
        const metadataValue = stepMeta[CreateApplicationDeceasedCmConstants.PAUPER_APPLICATION_TYPE_NAME_METADATA_KEY];
        if (metadataValue === null || metadataValue === undefined) {
            return "";
        }
        return String(metadataValue);
    }
    refreshBurialTypeValidationState() {
        if (this.deceasedForm === null || this.deceasedForm === undefined) {
            return;
        }
        const detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        if (detailsForm === null) {
            return;
        }
        const burialTypeControl = detailsForm.get(CreateApplicationDeceasedCmConstants.BURIAL_TYPE_FORM_CONTROL_NAME);
        if (burialTypeControl === null) {
            return;
        }
        const burialTypeText = this.getBurialTypeText(burialTypeControl.value);
        this.applyBurialTypeValidationState(burialTypeText);
    }
    clearPauperOptionalValidators() {
        const optionalControlNames = this.getPauperOptionalControlNames();
        optionalControlNames.forEach((controlName) => {
            this.clearControlValidators(controlName);
        });
        this.clearControlValidators(CreateApplicationDeceasedCmConstants.DECEASED_NAMES_FORM_CONTROL_NAME);
    }
    applyRequiredValidators() {
        const optionalControlNames = this.getPauperOptionalControlNames();
        optionalControlNames.forEach((controlName) => {
            this.applyRequiredValidator(controlName);
        });
        this.applyDeceasedNamesRequiredValidator();
    }
    getPauperOptionalControlNames() {
        return [
            ...CreateApplicationDeceasedCmConstants.PAUPER_OPTIONAL_FORM_CONTROL_NAMES,
            ...CreateApplicationDeceasedCmConstants.PAUPER_LEGACY_OPTIONAL_FORM_CONTROL_NAMES
        ];
    }
    clearControlValidators(controlName) {
        const control = this.deceasedForm.get(controlName);
        if (control === null) {
            return;
        }
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
    }
    applyRequiredValidator(controlName) {
        const control = this.deceasedForm.get(controlName);
        if (control === null) {
            return;
        }
        control.setValidators([Validators.required]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    applyDeceasedNamesRequiredValidator() {
        const control = this.deceasedForm.get(CreateApplicationDeceasedCmConstants.DECEASED_NAMES_FORM_CONTROL_NAME);
        if (control === null) {
            return;
        }
        control.setValidators([Validators.minLength(CreateApplicationDeceasedCmConstants.DECEASED_NAMES_MINIMUM_LENGTH)]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    buildRequiredFieldState(required) {
        return {
            sex: required,
            nationality: required,
            identificationType: required,
            idNumber: required,
            dateOfBirth: required,
            placeOfBirth: required,
            burialOrderNumber: required,
            verticalPosition: required
        };
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'Sex' or name eq 'Nationality' or name eq 'IDType' or name eq 'VerticalPosition')`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDeceasedCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const sexTypes = [];
        const idTypes = [];
        const verticalPositionTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "Sex") {
                    sexTypes.push(JSON.parse(item.content));
                }
                if (item.name === "IDType") {
                    idTypes.push(JSON.parse(item.content));
                }
                if (item.name === "VerticalPosition") {
                    verticalPositionTypes.push(JSON.parse(item.content));
                }
            });
        }
        sexTypes.sort((a, b) => a.value.localeCompare(b.value));
        idTypes.sort((a, b) => a.value.localeCompare(b.value));
        verticalPositionTypes.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("sexTypes", sexTypes);
        this.sexTypes = sexTypes;
        this.aflaModuleStrategyService.lookups.set("idTypes", idTypes);
        this.idTypes = idTypes;
        this.aflaModuleStrategyService.lookups.set("verticalPositionTypes", verticalPositionTypes);
        this.verticalPositionTypes = verticalPositionTypes;
        this.changeDetectorRefs.detectChanges();
    }
    arrayReturned(array) {
        this.tableSelection = array;
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = DeceasedNamesHeadingEnumHeadingLookup;
    }
    onBtnRemoveClicked($event) {
        if (this.tableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const deletedDocument = this.tableSelection;
        let index = 0;
        const itemsAlreadyOnTable = this.tableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === deletedDocument) {
                index = i;
            }
        }
        const options = {
            size: "sm",
            centered: true,
            keyboard: false,
            backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = index;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex !== undefined && deletedIndex !== null) {
                itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                this.tableDataSource.next(allItems);
                this.tableSelection = [];
                this.changeDetectorRefs.detectChanges();
                this.syncDeceasedNames();
            }
        }).catch((res) => { });
    }
    onBtnEditClicked($event) {
        if (this.tableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = this.tableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === this.tableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditDeceasedNameComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit deceased name";
        modalRef.componentInstance.deceasedName = this.tableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedName) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedName) {
                itemsAlreadyOnTable[updatedName[0]] = updatedName[1];
                const allItems = [...itemsAlreadyOnTable];
                this.tableDataSource.next(allItems);
                this.tableSelection = [];
                this.changeDetectorRefs.detectChanges();
                this.syncDeceasedNames();
            }
        }).catch((res) => { });
    }
    onBtnAddClicked($event) {
        const modalRef = this.modalService.open(AddDeceasedNameComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add deceased name";
        modalRef.componentInstance.recordCount = this.tableDataSource.getValue().length;
        modalRef.componentInstance.dateofBirth = this.dateofBirth;
        modalRef.result.then(newDeceasedName => {
            if (newDeceasedName) {
                const itemsAlreadyOnTable = this.tableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newDeceasedName];
                this.tableDataSource.next(allItems);
                this.tableSelection = [];
                this.changeDetectorRefs.detectChanges();
                this.syncDeceasedNames();
                this.deceasedForm.get(this.dateOfBirthFormControlName).setValue(this.tableDataSource.getValue()[0].startDate);
            }
        }).catch((res) => { });
    }
    syncDeceasedNames() {
        const items = this.tableDataSource.getValue();
        const formItems = this.deceasedForm.get("deceasedNames");
        formItems.clear();
        items.forEach(item => {
            const newItem = new FormGroup({
                name: new FormControl(item.name),
                surname: new FormControl(item.surname),
                startDate: new FormControl(item.startDate)
            });
            formItems.push(newItem);
        });
    }
    syncTable() {
        const items = [];
        const formItems = this.deceasedForm.get("deceasedNames");
        formItems.value.forEach(formItem => {
            // @ts-ignore
            if (typeof (formItem) === "FormGroup") {
                const item = {
                    name: formItem["name"].value,
                    surname: formItem["surname"].value,
                    startDate: formItem["startDate"].value
                };
                items.push(item);
            }
            else {
                items.push(formItem);
            }
        });
        this.tableDataSource.next(items);
        this.tableSelection = [];
        this.changeDetectorRefs.detectChanges();
    }
    dateOfBirthChanged() {
        const dob = this.deceasedForm.get(this.dateOfBirthFormControlName).value;
        const dod = this.deceasedForm.get(this.dateOfDeathFormControlName).value;
        this.dateofBirth = this.deceasedForm.get(this.dateOfBirthFormControlName).value;
        if (dob !== null && dod !== null && dob > dod) {
            this.deceasedForm.get(this.dateOfDeathFormControlName).setValue(null);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: NgbModal },
        { type: DatePipe },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDeceasedCmComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-deceased-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDeceasedCmComponent);
export { CreateApplicationDeceasedCmComponent };
